module.exports = __webpack_public_path__ + "static/media/logo.5e361eef.png";


//////////////////
// WEBPACK FOOTER
// ./src/logo.png
// module id = 302
// module chunks = 0